import { render, staticRenderFns } from "./RealTime.vue?vue&type=template&id=47d90026"
import script from "./RealTime.vue?vue&type=script&lang=js"
export * from "./RealTime.vue?vue&type=script&lang=js"
import style0 from "./RealTime.vue?vue&type=style&index=0&id=47d90026&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports